module.exports = __webpack_public_path__ + "img/img21.098b117d.png";